
export async function fawryCheckout(obj) {
    const configuration = {
      locale: 'en', //default en
      mode: DISPLAY_MODE.SEPARATED, //required, allowed values [POPUP, INSIDE_PAGE, SIDE_PAGE , SEPARATED]
    };
    FawryPay.checkout(await buildChargeRequest(obj), configuration);
}

async function buildChargeRequest({ merchantRefNum = '', price = '', customerMobile = '', customerEmail = '', customerName = '',returnUrl="" }) {
    const Secure_hash_key = '29133640-999b-4642-bbba-6ebd4cb6d190';
    const obj = {
    merchantCode: '770000015169', //form your company
    merchantRefNum: merchantRefNum, //form response id key
    customerMobile: customerMobile,
    customerEmail: customerEmail,
    customerName: customerName,
    paymentMethod: 'CARD',
    chargeItems: [
        {
            itemId: merchantRefNum, //form package-id
            price: Number(price).toFixed(2), //form response price key
            quantity: Number(1).toString(),
        },
    ],
    returnUrl:returnUrl,
    };
    const stringForSignature =
        obj.merchantCode +
        obj.merchantRefNum +
        '' +
        obj.returnUrl +
        obj.chargeItems[0].itemId +
        obj.chargeItems[0].quantity +
        obj.chargeItems[0].price +
        Secure_hash_key;

  //---------------------------------------------------------------------------------------------------------
    const chargeRequest = {
        ...obj,
        signature: await hashString(stringForSignature),
    };
    return chargeRequest;
}


async function hashString(input) {
    // Convert the string to an ArrayBuffer
    const encoder = new TextEncoder();
    const data = encoder.encode(input);

    // Use the subtle crypto API to calculate the SHA-256 hash
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    // Convert the hash to a hexadecimal string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');

    return hashHex;
}
